<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" ref="finder" v-model="isModalVisible" hide-footer :id="id" :title="title"
            @hidden="handleClean">
            <SolicitacaoManutencaoList :idItemBemPermanente="idItemBemPermanente" :prefix="nonUpdatedPrefix" :showTarefasTab='false'
                @onDblClickItem="itemSelect" />
        </b-modal>

        <lg-form-input-finder v-if="!modalOnly" :value="computedValue" @input="updateValue"
            :fieldDescription="fieldDescription" :label="label" :invalidFeedback="invalidFeedback"
            :description="description" @handleClean="handleClean">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import SolicitacaoManutencaoList from "../../modules/patrimonio/solicitacao-manutencao/SolicitacaoManutencaoList.vue"
export default {
    components: { LgFormInputFinder, SolicitacaoManutencaoList },
    props: {
        id: String,
        prefix: Array,
        value: Object,
        fieldDescription: String,
        label: String,
        invalidFeedback: String,
        description: String,
        idItemBemPermanente: {
            type: Number,
            default: null
        },
        modalOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isModalVisible: true,
            internalValue: this.value || {},
        }
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.internalValue
            },
            set(newValue) {
                this.internalValue = newValue
            },
        },
        nonUpdatedPrefix() {
            return [...this.prefix, ""].join(" > ")

        },
        updatedPrefix() {
            return [...this.prefix, "Solicitação de Manutenção"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    methods: {
        show() {
            this.$bvModal.show(this.id)
        },
        updateValue(newValue) {
            this.computedValue = newValue
            this.$emit('input', newValue)
        },
        handleClean() {
            this.computedValue = {}
            this.$emit('input', {})
        },
        itemSelect(item) {
            this.computedValue = item
            this.$emit('input', item)
            this.$bvModal.hide(this.id)
        },
    },
}
</script>